import AuthService from '../authService.js';
import OutsourcedUserFteItem from '../../Domain/OutsourcedUserFte/OutsourcedUserFteItem';
import FteTrackingItem from '../../Domain/OutsourcedUserFte/FteTrackingItem';
import SearchParams from '../../Elements/SearchParams';
import OutsourcedUserFteSearchParams from '../../Contents/User/UserAdmin/OutsourcedUserFteSearchParams';

export default class OutsourcedUserFteService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(
      searchItem,
      OutsourcedUserFteSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    return AuthService.getInstance().CallBackendFunction(
      `/api/OutsourcedUserFte/GetListBySearchingAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ChangeStatus(request) {
    const url = '/api/OutsourcedUserFte/ChangeStatus';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(request));
  }

  static GenerateIob(request) {
    const url = '/api/IobInvoiceMicro/GenerateOutsourcedFteIob';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(request));
  }

  static GenerateBonusIob(request) {
    const url = '/api/IobInvoiceMicro/GenerateOutsourcedFteBonusIob';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(request));
  }

  static CreateReverseIob(request) {
    const url = '/api/IobInvoiceMicro/CreateReverseIob';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(request));
  }

  static CreateReverseBonusIob(request) {
    const url = '/api/IobInvoiceMicro/CreateReverseBonusIob';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(request));
  }

  static GetWarnings(year, month) {
    const url = `/api/OutsourcedUserFte/GetWarnings?year=${year}&month=${month}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertFteTrackingItems(items) {
    if (!items) return [];
    return items.map((item) => new FteTrackingItem(item));
  }

  static GetByUserId(userId) {
    const authService = AuthService.getInstance();
    const url = `/api/OutsourcedUserFte/GetByUserId/${userId}`;
    return authService.CallBackendFunction(url);
  }

  static Create(item) {
    const url = 'api/OutsourcedUserFte/Create/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPost(url, JSON.stringify(item));
  }

  static Update(item) {
    const url = 'api/OutsourcedUserFte/Update/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url, JSON.stringify(item));
  }

  static Delete(id) {
    const url = `/api/OutsourcedUserFte/Delete/${id}`;
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionDelete(url);
  }

  static ConvertDBItems(items) {
    if (!items) return [];
    return items.map((item) => new OutsourcedUserFteItem(item));
  }
}
